import {h, Fragment} from "preact"
const breadcrumbs = document.querySelector('.breadcrumbs');

export default function Breadcrumbs() {
    return (
        breadcrumbs?.children?.length > 0 && 
            <nav
                class="breadcrumbs container container--inset"
                role="navigation"
                aria-label="breadcrumbs"
                dangerouslySetInnerHTML={{ __html: breadcrumbs.innerHTML }}
            />
    )
}
